// Shared helpers for the per-row image upload flow, extracted from the
// renamed-but-identical 10-method families in ModelQuickGroup.vue,
// ModelQuickReply.vue and ShortcutMenu.vue to remove duplicated code
// (SonarQube "Duplicated Lines") WITHOUT changing behavior.
//
// Each consuming component:
//  - declares `uploadInputElementId` in data() with the exact id of its hidden
//    <input type="file"> element,
//  - declares `indexImportFile` and `dialog` in data(),
//  - keeps its original public method names (Click_FileButtonH,
//    Click_FileButtonQuickReply, ...) as one-line wrappers so templates need
//    no edits, and keeps its own divergent Chang_*/`*Icon` final handler that
//    writes the resized data URL into its own state.
export default {
  methods: {
    getUploadFileInput() {
      return document.getElementById(this.uploadInputElementId);
    },

    resetUploadFileInput() {
      const fileInput = this.getUploadFileInput();
      if (fileInput) fileInput.value = "";
    },

    showUploadError(text) {
      this.$swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text,
        icon: "error",
      });
    },

    clearUploadError(text) {
      this.indexImportFile = null;
      this.resetUploadFileInput();
      this.dialog = false;
      this.showUploadError(text);
    },

    getSelectedUploadFile(e_para) {
      const file = e_para?.target?.files?.[0];
      return !file || file.size === 0 || this.indexImportFile == null ? null : file;
    },

    isSupportedUploadImage(file) {
      return file.type == "image/jpeg" || file.type == "image/png";
    },

    hasUploadFileExtension(file) {
      return file.name.lastIndexOf(".") > 0;
    },

    getResizedImageDimensions(width, height, maxWidth, maxHeight) {
      if (width > height && width > maxWidth) {
        return { width: maxWidth, height: height * (maxWidth / width) };
      }

      if (height >= width && height > maxHeight) {
        return { width: width * (maxHeight / height), height: maxHeight };
      }

      return { width, height };
    },

    loadUploadImage(file, onLoad) {
      const MAX_WIDTH = 120;
      const MAX_HEIGHT = 80;
      const fr = new FileReader();

      fr.readAsDataURL(file);
      fr.addEventListener("load", (e) => {
        const img = document.createElement("img");
        img.onload = () => {
          const { width, height } = this.getResizedImageDimensions(img.width, img.height, MAX_WIDTH, MAX_HEIGHT);
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          ctx.canvas.width = width;
          ctx.canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          onLoad(canvas.toDataURL(file.type));
        };
        img.src = e.target.result;
      });
    },

    clickUploadFileButton(_indexImportFile) {
      const fileInput = this.getUploadFileInput();
      if (fileInput) fileInput.click();
      this.indexImportFile = _indexImportFile;
    },
  },
};
